<template>
  <div class="yt-approval-subjects">
    <GridTable
      v-if="stateFilterBySchool"
      ref="gridTable"
      id="SubjectList"
      :key="componentKey"
      :title="`${title}${appendTitle || ''}`"
      urlPath="subjectsTutorsCms"
      :columns="columns"
      :schema="schema"
      :hasEditItem="false"
      :hasDeleteItem="false"
      :supportAddNew="false"
      :filterUrlUpdate="onFilterUrlUpdate"
      :defaultServerParams="{
        schoolId: filteredBySchool,
        _sort: 'createdAt',
        _order: 'desc'
      }"
    >
      <template v-slot:customButtons="slotProps">
        <ModalComponent
          v-if="slotProps.props.row.subjects.status === 'approved'"
          :id="slotProps.props.row.originalIndex"
          width="90%"
          :component="modalTutorSubjectDetail(slotProps.props.row)"
        >
          View
        </ModalComponent>
        <button
          v-else-if="slotProps.props.row.subjects.status === 'pending'"
          class="btn btn-info"
          type="button"
          @click="
            slotProps.onUpdateField(
              slotProps.props,
              'approved',
              'subjects.status'
            )
          "
        >
          Approve
        </button>
      </template>
    </GridTable>
  </div>
</template>

<script>
import { Component, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import BaseList from '@/components/BaseList'

const appModule = namespace('app')
const subjectsModule = namespace('subjects')

@Component()
export default class ApprovalSubjects extends BaseList {
  @appModule.State('schools') stateSchools
  @appModule.State('filterBySchool') stateFilterBySchool
  @subjectsModule.State('statuses') stateStatuses

  title = 'Pending Tutor Approval'

  schema = null

  get columns() {
    return [
      {
        label: 'ID',
        field: '_id',
        hidden: true
      },
      {
        label: 'Active',
        field: 'subjects.isActive',
        type: 'switch'
      },
      {
        label: 'Name',
        field: rowObj => {
          return (
            rowObj.student &&
            `${rowObj.student.firstName} ${rowObj.student.lastName}`
          )
        }
      },
      /* {
                label: 'First Name',
                field: 'student.firstName',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: 'Filter by First Name', // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: 'keyup' // only trigger on enter not on keyup
                }
            },
            {
                label: 'Last Name',
                field: 'student.lastName',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: 'Filter by Last Name', // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: 'keyup' // only trigger on enter not on keyup
                }
            }, */
      {
        label: 'School',
        field: rowObj => {
          const email = rowObj.student && rowObj.student.schoolEmail
          const brk = typeof email === 'string' && email.split('@')
          return brk.length > 0 && brk[1]
        },
        alias: 'schoolName'
      },
      {
        label: 'Subject',
        field: 'subjects.name',
        filterOptions: {
          enabled: false,
          placeholder: 'Filter by Subject',
          trigger: 'keyup'
        }
      },
      /* {
                label: 'Total Lessons',
                field: 'subjects.totalLessons',
                type: 'number'
            },
            {
                label: 'Total Minutes',
                field: 'subjects.totalMinutes',
                type: 'number'
            }, */
      {
        label: '+ Rates',
        field: 'subjects.totalPositiveRates',
        type: 'number'
      },
      {
        label: '- Rates',
        field: 'subjects.totalNegativeRates',
        type: 'number'
      },
      {
        label: 'Registration Date',
        field: 'subjects.registrationDate'
        // type: 'date',
        // dateInputFormat: 'YYYY-MM-DD', // expects 2018-03-16
        // dateOutputFormat: 'MMM Do YYYY'
      },
      {
        label: 'Status',
        field: 'subjects.status',
        type: 'dropdown',
        options: this.statuses,
        filterOptions: {
          enabled: true,
          placeholder: 'Filter by Status',
          filterValue: '',
          filterDropdownItems: this.statuses,
          filterFn: this.columnFilterFn,
          trigger: 'enter'
        }
      },
      {
        label: 'Actions',
        field: 'actions'
        /* type: 'dinamicView',
                dinamicView: {
                    buttonLabel: 'View',
                    modalTitle: 'Lesson Detail',
                    component: () => import('@/components/lessons/LessonDetail')
                } */
      }
    ]
  }

  get statuses() {
    if (!this.stateStatuses) {
      return []
    }

    return this._.map(this.stateStatuses, (text, value) => {
      return { value, text }
    })
  }

  @Watch('statuses', { immediate: true })
  loadStatuses() {
    this.columns.find(
      item => item.field === 'subjects.status'
    ).options = this.statuses
  }

  @Watch('filteredBySchool', { immediate: true })
  onChangeFilterBySchool() {
    if (!Array.isArray(this.stateSchools)) {
      return false
    }

    const currentSchool = this.stateSchools.find(
      item => item.id === this.filteredBySchool
    )
    this.appendTitle =
      currentSchool && currentSchool.name
        ? ` <i>(School: ${currentSchool.name})</i>`
        : ''

    this.columns.find(f => f.alias === 'schoolName').hidden = !!this
      .filteredBySchool
    this.componentKey++
  }

  onFilterUrlUpdate(defaultUrl, props) {
    return `${defaultUrl}?subjectId=${props.row.subjects.subject}`
  }

  modalTutorSubjectDetail(item) {
    return {
      modalTitle: 'Subject Detail',
      component: () => import('@/components/students/_TutorSubjectDetail'),
      componentProps: {
        item,
        statusOptions: this.statuses
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/subjects/ApprovalSubjects.vue